<mat-toolbar>個人設定</mat-toolbar>
<mat-accordion multi>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>パスワード変更 <span *ngIf='!passwordChanged' class='error'>&emsp;仮パスワードから変更後にシステムが利用可能になります。</span></mat-panel-title>
        </mat-expansion-panel-header>
        <app-password-change></app-password-change>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>打刻履歴ページ締め日設定</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field>
            <mat-select placeholder="締め日" id="closingDay" name="closingDay" [(ngModel)]="selectClosingDayIndex" #closingDay="ngModel">
              <mat-option *ngFor="let m of closingDays" [value]="m.id">{{m.value}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-card-actions>
            <button mat-raised-button (click)="saveClosingDaySettting()">保存</button>
        </mat-card-actions>
    </mat-expansion-panel>

</mat-accordion>
